import { View, useWindowDimensions } from 'react-native'
import {useEffect, useState} from 'react'
import { CardInterlude } from '../../element/Card'
import { Tribe } from '../../List/TribeList'
import {doc, setDoc, query, collection, where, getDocs} from 'firebase/firestore';
import { db } from '../../firebase/FirebaseConfig'
import { auth } from '../../firebase/FirebaseConfig'


export default function Interlude({route, navigation}) {
    const windows=useWindowDimensions()
    const [idPg, setIdPg]=useState("")
    const [usname, setName]=useState("")
    const {Tribi}=route.params
   

    const user= auth.currentUser

    useEffect(()=>{
      const unsubscribe = navigation.addListener('focus', () => {
      kimera()})
    
},[navigation])

async function kimera(){
  console.log(user.email)
  let png=[]
  let information=query(collection(db,"utenti"),where("email","==",user.email));
  let querySnapshot= await getDocs(information);
        querySnapshot.forEach((docs)=>{png.push(docs.data().name);});
        var name=png[0]
        console.log(name)
        setTimeout(5000)
        NewPG(name);
        }


   
     
  async function NewPG(name){
     var a =Makeid()
     setName(usname)
     await setDoc(doc(db, "personaggi", a), {
     Name:'',
     Tribe: Tribi,
     User: user.uid,
     UserName:name,
     Death: false,
     Key: a,
     Background:'',
     Abilita: ["CONOSCENZE TRIBU'"],
     Sign:'',
     Complete:false,
     Mod:true,
     Mage:false,
     Erinni:'',
     Arcane:[],});
   setIdPg(a)}

 

 function Makeid() {
   var text = "";
   let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
   for (let i = 0; i < 20; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
   return text;}



  return (
    <View style={{alignItems:'center', justifyContent:'center', width:windows.width, height:windows.height}}>
      <CardInterlude image={Tribe[Tribe.findIndex((obj)=>obj.name===Tribi)].image} title={Tribe[Tribe.findIndex((obj)=>obj.name===Tribi)].name} onPress={()=>{navigation.navigate('PgMaker', {Tribi, idPg, usname})}} onPress1={()=>{navigation.navigate('Home')}}/> 
    </View>
  )
}

